import { GetHeader } from "../common"

const URL = process.env.REACT_APP_API_USER!

export interface typeUserInfo {
  userCd: string,
  termCd: string,
  startDate: string,
  endDate: string,
  telephoneNumber: string | null,
  mobileNumber: string | null,
  faxNumber: string | null,
  extensionNumber: string | null,
  extensionFaxNumber: string | null,
  countryCd: string | null,
  zipCode: string | null,
  emailAddress1: string | null,
  emailAddress2: string | null,
  mobileEmailAddress: string | null,
  url: string | null,
  localeId: string,
  userName: string,
  userNameSyllabary: string | null,
  userNameEng: string | null,
  address: string | null,
  companyCd: string,
  departmentCd: string | null,
  departmentName: string | null,
  departmentNameSyllabary: string | null,
  departmentNameEng: string | null,
  address1: string | null,
  address2: string | null,
}

export interface typeMenuList {
  menuId: string;
  menuType: string;
  notes: string;
  sortNumber: string;
  clientType: string;
  contents: string;
  url: string;
  parentMenuId: string;
  imagePath: string;
  localeId: string;
  displayName: string;
  menu: Array<{
    menuId: string;
    menuType: string;
    notes: string;
    sortNumber: string;
    clientType: string;
    contents: string;
    url: string;
    parentMenuId: string;
    imagePath: string;
    localeId: string;
    displayName: string;
    menu: Array<{
      menuId: string;
      menuType: string;
      notes: string;
      sortNumber: string;
      clientType: string;
      contents: string;
      url: string;
      parentMenuId: string;
      imagePath: string;
      localeId: string;
      displayName: string;
      menu: undefined[]
    }>
  }>
}

//005 ユーザー情報取得(会社ユーザー) 完了
export const getUserInfo = async (userid: string, tokenUser: string, token: string, role: string): Promise<typeUserInfo> => {
  const header = GetHeader(tokenUser, token, role)
  const res = await fetch(`${URL}/user/${userid}`, header).then(response => {
    if (response.ok) {
      return response.json()
    } else {
      throw response
    }
  })
  return res
}

//006 メニュー情報取得 完了
export const getMenuList = async (userid: string, token: string, role: string): Promise<typeMenuList[]> => {
  const header = GetHeader(userid, token, role)
  const res = await fetch(`${URL}/menu/${userid}`, header).then(response => {
    if (response.ok) {
      return response.json()
    } else {
      throw response
    }
  })
  return res
}